// extracted by mini-css-extract-plugin
export default {"saved-root":"Saved_saved-root__+XpPa","icon":"Saved_icon__sRB5q","content":"Saved_content__FhzcZ","details":"Saved_details__Is3y-"};